import { render, staticRenderFns } from "./FormObservaciones.vue?vue&type=template&id=51334c5e&"
import script from "./FormObservaciones.vue?vue&type=script&lang=js&"
export * from "./FormObservaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports